import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { StackNavigator } from './navigation/StackNavigator';

import { RootState } from './store';

function App() {
  const color = useSelector((state: RootState) => state.bgSlice.color);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/android|iPad|iPhone|iPod/i.test(userAgent.toLowerCase())) {
      setIsMobile(true);
    }
  }, []);

  if (!isMobile) {
    return (
      <div className="app" style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(245, 250, 251)" }}>
        <h2>Please scan using your mobile phone.</h2>
      </div>
    );
  }

  return (
    <div
      className='app'
      style={{ backgroundColor: color }}
    >
      <StackNavigator />
    </div>
  );
}

export default App;
